import { Footer } from '»components/templates';
import { useAppBarContext } from '»utils/customHooks';

import { AppCard } from '../../app';
import { LandingPageContainer } from './LandingPage.styles';

export const LandingPage = () => {
  const { barHeight } = useAppBarContext();

  return (
    <LandingPageContainer barHeight={barHeight}>
      <AppCard />
      <Footer />
    </LandingPageContainer>
  );
};
